import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { SupplierConditionsFormValues } from './models/supplier-conditions-form-values';

const fieldNames = fields<SupplierConditionsFormValues>();

/**
 * What the conditions tab insists on.
 *
 * The delivery term is no longer among it: of 3.434 suppliers on record 1.978
 * carry none, and the GF decided it is not a mandatory field (#2212, R-28).
 * Payment term and Gegenkonto stay mandatory, but only where the mask can
 * reasonably ask for them — see supplierDetailConditionsValidationSchemaNew.
 */
export const supplierDetailConditionsValidationSchema = Yup.object().shape({
    [fieldNames.deliveryTermId]: Yup.number(),
    [fieldNames.paymentTermId]: Yup.number().required('app.error.required'),
    [fieldNames.paymentMethod]: Yup.string().required('app.error.required'),
    [fieldNames.bonusClassification]: Yup.string()
        .nullable(true)
        .when([fieldNames.bonusClassificationFrom, fieldNames.bonusClassificationTo], {
            is: (bonusClassification: string, bonusClassificationFrom: Date, bonusClassificationTo: Date) =>
                bonusClassification && (bonusClassificationFrom || bonusClassificationTo),
            then: Yup.string().required('app.error.required'),
        }),
    [fieldNames.bonusClassificationFrom]: Yup.date().nullable(true),
    [fieldNames.bonusClassificationTo]: Yup.date()
        .nullable(true)
        .min(Yup.ref('bonusClassificationFrom'), 'app.error.minStartDate'),
    [fieldNames.taxRateId]: Yup.number().typeError('app.error.required').required('app.error.required'),
    [fieldNames.bonusTaxRateId]: Yup.number().typeError('app.error.required').required('app.error.required'),
});
